import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { useEditor } from "../../hooks/EditorProvider";
import DraggableBox from "./DraggableBox";
const RenderDraggableElement = ({ elementProps, elementId }) => {
    const { mode } = useEditor();
    if (mode === "production") {
        return (_jsx(DraggableBox, { draggableId: "1", elementId: elementId, childs: elementProps?.children || [], component: Fragment }));
    }
    return (_jsx("div", { "editor-elementid": elementId, className: "editor-draggable", children: _jsx("div", { className: "w-full", "editor-elementid": elementId, "editor-draggable": "true", children: _jsx(DraggableBox, { draggableId: "1", elementId: elementId, childs: elementProps?.children || [] }) }) }));
};
export default RenderDraggableElement;
//# sourceMappingURL=RenderDraggableElement.js.map